// Adapté de: https://gist.github.com/cb109/b074a65f7595cffc21cea59ce8d15f9b

var breakpoint = {
  data() {
    return {
      clientWidth: 0,
      clientHeight: 0
    }
  },
  computed: {
    $breakpoint() {
      let mobile = this.clientWidth < 769
      let tablet = this.clientWidth < 1024 && !mobile
      let desktop = this.clientWidth < 1216 && !(tablet || mobile)
      let widescreen = this.clientWidth < 1408 && !(desktop || tablet || mobile)
      let fullhd = this.clientWidth >= 1408 && !(widescreen || desktop || tablet || mobile)

      let mobileOnly = mobile
      let tabletOnly = tablet
      let tabletAndDown = (mobile || tablet) && !(desktop || widescreen || fullhd)
      let tabletAndUp = !mobile && (tablet || desktop || widescreen || fullhd)
      let desktopOnly = desktop
      let desktopAndDown = (mobile || tablet || desktop) && !(widescreen || fullhd)
      let desktopAndUp = !(mobile || tablet) && (desktop || widescreen || fullhd)
      let widescreenOnly = widescreen
      let widescreenAndDown = (mobile || tablet || desktop || widescreen) && !fullhd
      let widescreenAndUp = !(mobile || tablet || desktop) && (widescreen || fullhd)
      let fullhdOnly = fullhd

      let name
      switch (true) {
        case mobile:
          name = 'mobile'
          break
        case tablet:
          name = 'tablet'
          break
        case desktop:
          name = 'desktop'
          break
        case widescreen:
          name = 'widescreen'
          break
        default:
          name = 'fullhd'
          break
      }

      let result = {
        // Definite breakpoint.
        mobile: mobile,
        tablet: tablet,
        desktop: desktop,
        widescreen: widescreen,
        fullhd: fullhd,

        // Useful e.g. to construct CSS class names dynamically.
        name: name,

        // Breakpoint ranges.
        mobileOnly: mobileOnly,
        tabletOnly: tabletOnly,
        tabletAndDown: tabletAndDown,
        tabletAndUp: tabletAndUp,
        desktopOnly: desktopOnly,
        desktopAndDown: desktopAndDown,
        desktopAndUp: desktopAndUp,
        widescreenOnly: widescreenOnly,
        widescreenAndDown: widescreenAndDown,
        widescreenAndUp: widescreenAndUp,
        fullhdOnly: fullhdOnly,

        // For custom breakpoint logic.
        width: this.clientWidth,
        height: this.clientHeight
      }
      return result
    }
  },
  methods: {
    _updateDimensions() {
      // Cross-browser support as described in:
      // https://stackoverflow.com/questions/1248081
      this.clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      this.clientHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this._updateDimensions()
      window.addEventListener('resize', this._updateDimensions, { passive: true })
    })
  },
  destroyed() {
    window.removeEventListener('resize', this._updateDimensions)
  }
}

export default breakpoint
